export const styles: any = {
  flexDirection: { base: 'column', lg: 'row' },
};
